var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarmenCathedral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5491 44.4903L25.0944 42.1826L25.0944 37.8992L26.0696 35.016L26.0953 34.94L26.0157 34.9504L7.56649 37.3697L7.5536 37.3697C6.86722 37.3697 6.22718 37.5354 5.73285 37.8487C5.23928 38.1616 4.95 38.5851 4.95 39.0383L4.95 41.0565C4.95 41.5251 5.24728 41.9434 5.71449 42.2422C6.18173 42.541 6.82478 42.7247 7.53489 42.7252L25.4949 44.5497L25.5621 44.5566L25.5491 44.4903Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9289 44.4894L54.4506 42.0753L54.9047 37.8965L53.9304 35.016L53.9047 34.94L53.9843 34.9504L72.4335 37.3697L72.4464 37.3697C73.1328 37.3697 73.7728 37.5354 74.2672 37.8487C74.7607 38.1616 75.05 38.5851 75.05 39.0383L75.05 41.0565C75.05 41.5251 74.7527 41.9434 74.2855 42.2422C73.8183 42.541 73.1752 42.7247 72.465 42.7252L53.9827 44.5498L53.9144 44.5565L53.9289 44.4894Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0507 29.9993H29.5543V50.3245H50.0507V29.9993Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4463 40.1619C24.4463 48.5493 31.3182 55.3633 39.7525 55.3901V55.4066H39.8025C48.2762 55.4066 55.1587 48.5822 55.1587 40.1783C55.1587 31.7744 48.2762 24.95 39.8025 24.95C31.3289 24.95 24.4463 31.7579 24.4463 40.1619ZM25.3563 40.1783C25.3563 32.2729 31.8295 25.8532 39.8025 25.8532C47.759 25.8532 54.2488 32.273 54.2488 40.1783C54.2488 48.0837 47.7755 54.5034 39.8025 54.5034C31.8295 54.5034 25.3563 48.0837 25.3563 40.1783Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7878 25.7905L25.2947 40.1626L39.7878 54.5346L54.281 40.1626L39.7878 25.7905Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarmenCathedral);
export default __webpack_public_path__ + "static/media/CarmenCathedral.bbdbb3ada3e17c098157d3f11b1afa50.svg";
export { ForwardRef as ReactComponent };